import { Link } from 'react-router-dom'
import logo from '../../../assets/img/logo.svg'
import { AppMenu } from './AppMenu'
import styles from './Sidenav.module.scss'

export const Sidenav = () => {
  return (
    <div className="sidenav-menu" id="sidenav">
      <Link to="/app/overview" className="logo text-decoration-none pt-3">
        <span className="logo-lg">
          <span className="d-inline-flex align-items-center">
            <img src={logo} alt="Total Milk Hauler" className={styles.brandLogo} />
            <span className="d-inline-flex flex-column align-items-start ms-2">
              <span className={`fw-semibold text-white lh-1 ${styles.brandTitle}`}>Total Milk Hauler</span>
              <span className={styles.nextBadge}>Next</span>
            </span>
          </span>
        </span>
        <span className="logo-sm">
          <img src={logo} alt="Total Milk Hauler" className={styles.brandLogo} />
        </span>
      </Link>

      <div className="scrollbar" style={{ overflowY: 'auto', height: 'calc(100% - var(--bs-topbar-height, 65px))' }}>
        <div id="sidenav-menu">
          <AppMenu />
        </div>
      </div>
    </div>
  )
}
